import { render, staticRenderFns } from "./AdminInstancerForm.vue?vue&type=template&id=4472e50f&"
import script from "./AdminInstancerForm.vue?vue&type=script&lang=js&"
export * from "./AdminInstancerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports